import { getBottomPadding } from '../../utils/sessionStorage'

/**
 * RebalancingDisclaimer Component
 *
 * A reusable component that displays the standard disclaimer text for rebalancing recommendations.
 * This disclaimer appears at the bottom of rebalancing-related pages.
 *
 * @example
 * <RebalancingDisclaimer />
 */
export default function RebalancingDisclaimer() {
  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 60px)` }}
      className='pt-8 px-5 text-sm bg-grey80 text-[12px] text-grey40'
    >
      <p> All recommendations are thoroughly backtested by our in-house SEBI registered experts.</p>
      <br />
      <p>
        {' '}
        We understand that past success of backtesting doesn't guarantee future returns, and neither do we. Rest
        assured, we are actively monitoring your portfolio with our proprietary rating engine built by our experts, to
        give the best possible results on your investments. We do the hard work, so you don't have to.
      </p>
      <br />
      <p>
        {' '}
        The recommendations are based on available data and uses our best judgement to help you keep your portfolio in
        top form. This is not a guarantee of returns in any way. The final judgement of acting on the recommendations
        lie solely with you.
      </p>
      <br />
      <p>
        {' '}
        Disclaimer: Information provided is intended solely for the client's consumption and should not be
        redistributed. Mutual fund investments are subject to market risks. Registration granted by SEBI, enlistment as
        IA with Exchange and certification from NISM do not guarantee the performance of any intermediary or provide any
        assurance of returns.
      </p>
    </div>
  )
}
